import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';


const AdminButton = ({ style, onClick, inverse, disabled, color, ...rest }) => {
  const buttonColors = inverse ?
    { color, backgroundColor: 'transparent' } :
    { color: '#FFF', backgroundColor: color };

  return (
    <span
      onClick={disabled ? _.noop : onClick}
      className='helvetica-neue-bold'
      {...rest}
      style={{
        ...buttonColors,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 130,
        borderRadius: 4,
        padding: 5,
        fontSize: 16,
        textDecoration: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}/>
  );
};

AdminButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inverse: PropTypes.bool,
  color: PropTypes.string,
};

AdminButton.defaultProps = {
  color: '#ffffff59'
};

export default AdminButton;